// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Restrained palette — readable, not flashy */
/* Header strip only — cool sky/slate + blue accent (matches blue/teal UI, no red/warm) */
:host {
  display: block;
  height: 100%;
  overflow: hidden;
}

.routing-dialog-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.routing-ruleconfig-container {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  font-size: 12px;
  background-color: #ffffff;
}

/* Header — subtle depth, clear title */
.rule-builder-header {
  flex-shrink: 0;
  min-height: auto;
  width: 100%;
  font-size: 13px;
  font-weight: 600;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #0f172a;
  background: linear-gradient(180deg, #f8fafc 0%, #f0f9ff 45%, #e0f2fe 100%);
  border-bottom: 1px solid #bae6fd;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.95) inset, 0 2px 10px rgba(37, 99, 235, 0.09);
}

.routing-page-heading {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #0f172a;
  border-left: 4px solid #2563eb;
  padding-left: 12px;
  line-height: 1.3;
  text-shadow: 0 0 0 transparent;
}

.rule-builder-header .btn_style {
  background-color: rgba(255, 255, 255, 0.95);
  color: #1d4ed8;
}

.rule-builder-header .btn_style:disabled {
  opacity: 0.5;
}

.rule-builder-title-row {
  flex: 1;
}

.rule-builder-version-field {
  flex: 0 0 auto;
  min-width: 160px;
  max-width: 260px;
}

:host ::ng-deep .rule-builder-header .rule-builder-version-field .mat-mdc-form-field {
  font-size: 12px;
}
:host ::ng-deep .rule-builder-header .rule-builder-version-field .mat-mdc-text-field-wrapper {
  background: #ffffff;
  border-radius: 6px;
  padding-top: 0;
  padding-bottom: 0;
  height: 36px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}
:host ::ng-deep .rule-builder-header .rule-builder-version-field .mat-mdc-form-field-infix {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  min-height: 36px !important;
}
:host ::ng-deep .rule-builder-header .rule-builder-version-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .rule-builder-header .rule-builder-version-field .mat-mdc-select-value,
:host ::ng-deep .rule-builder-header .rule-builder-version-field .mat-mdc-floating-label {
  color: #1d4ed8 !important;
  font-size: 12px !important;
}

/* Rules list — top of right column */
.routing-body {
  order: 2;
  background-color: #f9fafb;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.routing-body > .routing-expression-bar {
  flex-shrink: 0;
  margin-top: auto;
}

/* Rule build form — directly under rules table */
.routing-common-form {
  flex-shrink: 0;
  margin: 0;
  padding: 8px 12px 6px;
  border: none;
  border-radius: 0;
  background: linear-gradient(180deg, #fafbfc 0%, #f1f5f9 100%);
  box-sizing: border-box;
}

/* Inner form shell — same idea as create-rules-container + part-1 / part-2 */
.routing-rules-form-container {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
}

/* Grid 46:14:36 — same as Rule Config; columns stay fixed on add and edit */
.routing-rule-part-1 {
  display: grid;
  grid-template-columns: minmax(0, 46fr) minmax(0, 14fr) minmax(0, 36fr);
  gap: 6px;
  align-items: start;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
}

.routing-rule-part-1 > .routing-field-cell,
.routing-rule-part-1 > .routing-select-operator,
.routing-rule-part-1 > .routing-value,
.routing-rule-part-1 > .routing-value-col {
  min-width: 0;
  width: 100%;
  max-width: 100%;
}

.routing-field {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.routing-select-operator {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.routing-value,
.routing-value-col {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.routing-rule-part-1--has-value-chips {
  overflow: visible;
}

/* HL7: field shrink-wrap, operator fixed width, value fills remaining row */
.routing-rule-part-1--hl7 {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 6px;
  width: 100%;
}

.routing-rule-part-1--hl7.routing-rule-part-1--has-value-chips {
  align-items: flex-start;
}

.routing-rule-part-1--hl7 > .routing-field-cell--hl7 {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  justify-self: auto;
}

.routing-rule-part-1--hl7 > .routing-select-operator {
  flex: 0 0 112px;
  width: 112px;
  min-width: 112px;
  max-width: 112px;
}

.routing-rule-part-1--hl7 > .routing-value-col,
.routing-rule-part-1--hl7 > .routing-value.mat-mdc-form-field {
  flex: 1 1 0;
  min-width: 120px;
  width: 100%;
  max-width: 100%;
}

.routing-rule-part-1--hl7 .routing-hl7-field-group,
.routing-rule-part-1--hl7 .routing-hl7-field-row {
  width: auto;
  max-width: none;
}

:host ::ng-deep .routing-rule-part-1--hl7 .routing-select-operator.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-floating-label,
:host ::ng-deep .routing-rule-part-1--hl7 .routing-select-operator.mat-mdc-form-field:not(.rule-value-inline-field) .mdc-floating-label {
  top: -9px !important;
  transform: scale(0.75) !important;
  transform-origin: left top;
  background: #fff;
  padding: 0 4px;
  z-index: 1;
}
:host ::ng-deep .routing-rule-part-1--hl7 .routing-select-operator.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-rule-part-1--hl7 .routing-select-operator.mat-mdc-form-field:not(.rule-value-inline-field) .mdc-text-field--outlined {
  min-height: 36px;
  height: 36px;
}
:host ::ng-deep .routing-rule-part-1--hl7 .routing-select-operator.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-form-field-infix {
  min-height: 36px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
:host ::ng-deep .routing-rule-part-1--hl7 .routing-select-operator.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-select-trigger {
  min-height: 20px;
  height: 20px;
}
:host ::ng-deep .routing-rule-part-1--hl7 .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-rule-part-1--hl7 .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mdc-text-field--outlined {
  min-height: 36px;
  height: 36px;
}

.routing-value-col .rule-value-inline-field.mat-mdc-form-field {
  width: 100%;
  margin: 0;
}

.routing-rule-part-2--has-value-chips {
  align-items: center;
}

/* HL7 part-2: align Rule Name under field, buttons under value column */
.routing-rule-part-2--hl7 {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.routing-rule-part-2--hl7 > .routing-rulename-cell {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
  max-width: none;
}

.routing-rule-part-2--hl7 > .routing-part-2-operator-spacer {
  flex: 0 0 112px;
  width: 112px;
  min-width: 112px;
  max-width: 112px;
}

.routing-rule-part-2--hl7 > .routing-form-actions {
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
}

/* Same 46:14:36 grid as part-1 */
.routing-rule-part-2 {
  display: grid;
  grid-template-columns: minmax(0, 46fr) minmax(0, 14fr) minmax(0, 36fr);
  gap: 6px;
  align-items: center;
  width: 100%;
  padding: 0;
  margin-top: 0;
  box-sizing: border-box;
}

.routing-pipeline-cell {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.routing-part-2-operator-spacer {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.routing-pipeline {
  width: 100%;
}

/* Pipeline ng-autocomplete — align with create pipeline field */
.routing-pipeline-autocomplete {
  width: 100%;
  min-width: 0;
}

:host ::ng-deep .routing-pipeline-autocomplete .ng-autocomplete {
  width: 100%;
}

:host ::ng-deep .routing-pipeline-autocomplete .autocomplete-container {
  width: 100%;
  box-sizing: border-box;
}

:host ::ng-deep .routing-pipeline-autocomplete .input-container {
  font-size: 12px;
  min-height: 36px;
  height: 36px;
  border: 1px solid #cfd8e3;
  border-radius: 4px;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.routing-form-actions {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  box-sizing: border-box;
}

.add-or-edit-button,
.clear-button {
  color: #ffffff;
  font-size: 10px;
  padding: 1px 8px;
  min-height: 26px;
}

.routing-footer {
  flex-shrink: 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 20px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f0fdfa 0%, #e6f7f3 100%);
  border-top: 1px solid #bfe6dd;
  box-shadow: 0 -2px 10px rgba(15, 118, 110, 0.08);
}

.routing-footer-spacer {
  flex: 1;
}

.routing-footer-btn {
  font-size: 11px;
  padding: 4px 12px;
  box-shadow: 0 1px 2px rgba(15, 118, 110, 0.18);
}

.routing-footer-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(15, 118, 110, 0.22);
}

/* Pipeline accordion — fills top of right column */
.pipeline-accordion {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 8px 16px;
  background-color: #f9fafb;
}

.pipeline-parent {
  margin-bottom: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 2px rgba(15, 23, 42, 0.04);
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.pipeline-parent.pipeline-expanded {
  flex: 1;
  min-height: 0;
}

.pipeline-parent-header {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: #ecfdf5;
  border: none;
  border-left: 3px solid #0f766e;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 600;
  font-size: 12px;
  color: #115e59;
  transition: background-color 0.15s ease, border-left-color 0.15s ease, box-shadow 0.15s ease;
}

.pipeline-parent-header:hover {
  background: #d1fae5;
  border-left-color: #0d9488;
}

.pipeline-parent-header.expanded {
  background: #ccfbf1;
  border-left-color: #0f766e;
  box-shadow: inset 0 -1px 0 rgba(15, 118, 110, 0.08);
}

.pipeline-chevron {
  width: 18px;
  margin-right: 6px;
  flex-shrink: 0;
  font-size: 11px;
}

.pipeline-label-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pipeline-label-copy {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.pipeline-rule-count {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
}

.pipeline-add-rule-btn {
  margin-right: 8px;
  border: 1px solid #7dd3c9;
  background: #f0fdfa;
  color: #0f766e;
  border-radius: 4px;
  font-size: 10px;
  line-height: 1;
  padding: 3px 7px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}
.pipeline-add-rule-btn:hover {
  background: #ccfbf1;
  border-color: #14b8a6;
}

.pipeline-delete-block-btn {
  margin-right: 8px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  color: #64748b;
  border-radius: 4px;
  font-size: 10px;
  line-height: 1;
  padding: 3px 7px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}
.pipeline-delete-block-btn:hover {
  background: #fef2f2;
  border-color: #fca5a5;
  color: #b91c1c;
}

.pipeline-children {
  padding: 12px 14px 14px 14px;
  border: none;
  border-top: 1px solid #e2e8f0;
  border-radius: 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.pipeline-children-scroll {
  flex: 1 1 auto;
  min-height: 120px;
  overflow-y: auto;
  overflow-x: hidden;
}

.pipeline-parent.pipeline-expanded .pipeline-children {
  background-color: #fafafa;
}

/* Table header */
.rule-display-header {
  width: 100%;
  margin-bottom: 2px;
}

.rule-display-header .row,
.routing-rules-list .routing-rule-row .row {
  margin-left: 0;
  margin-right: 0;
  width: 100%;
}

.rule-display-header-sub-1 {
  display: flex;
  align-items: center;
  width: 100%;
}

.routing-header-cell {
  color: #ffffff !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em;
  padding: 0 !important;
}

/* Brighter teal (matches earlier rule-builder look) — not the dark pine gradient */
.rule-display-header .rule-display-header-sub-1 {
  background-color: #0da7ad;
  border-radius: 3px 3px 0 0;
  padding: 4px 6px;
  box-shadow: none;
}

.rule-display-header .cardContect {
  color: #ffffff;
}

.routing-rules-list {
  min-height: 48px;
  max-height: none;
  margin-bottom: 0;
}

.routing-rule-row {
  padding: 8px 10px !important;
  border-radius: 6px;
  transition: background-color 0.12s ease, border-color 0.12s ease, box-shadow 0.12s ease;
  background-color: #ffffff;
  border: 1px solid #e8ecf0;
}

.routing-rule-row:hover {
  background-color: #f0fdfa;
  border-color: #99f6e4;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.routing-rule-row .cardContect {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 11px;
  color: #334155;
}

.rule-name-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  max-width: 100%;
}

.rule-in-expression-icon {
  color: #16a34a;
  font-size: 14px;
  flex-shrink: 0;
}

.routing-copyable-cell {
  cursor: copy;
}

.routing-copyable-cell:hover {
  text-decoration: underline;
  color: #0f766e;
}

/* Edit / Delete icons */
.routing-rule-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

/*
 * Global .addconfigbtn (VSstyles) forces teal bg + white text; icons often stay dark.
 * Override here so row actions stay light with readable icons.
 */
.routing-rule-actions .addconfigbtn.edit_btn,
.routing-rule-actions .addconfigbtn.delete-btn {
  background-color: #ffffff !important;
  border: 1px solid #b8d4da !important;
  padding: 3px 6px !important;
  min-width: 26px !important;
  min-height: 26px !important;
  height: auto !important;
  line-height: 1 !important;
  font-size: 12px;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.routing-rule-actions .addconfigbtn.edit_btn .fa,
.routing-rule-actions .addconfigbtn.delete-btn .fa {
  font-size: 15px !important;
  line-height: 1 !important;
}

.routing-rule-actions .addconfigbtn.edit_btn {
  color: #0da7ad !important;
}
.routing-rule-actions .addconfigbtn.edit_btn .fa {
  color: #0da7ad !important;
}
.routing-rule-actions .addconfigbtn.edit_btn:hover {
  background-color: #e0f7f7 !important;
  border-color: #0da7ad !important;
}

.routing-rule-actions .addconfigbtn.delete-btn {
  color: #5a6b7a !important;
}
.routing-rule-actions .addconfigbtn.delete-btn .fa {
  color: #5a6b7a !important;
}
.routing-rule-actions .addconfigbtn.delete-btn:disabled, .routing-rule-actions .addconfigbtn.delete-btn[disabled] {
  opacity: 0.45;
  cursor: not-allowed !important;
  pointer-events: none;
  background-color: #f1f5f6 !important;
  border-color: #d0dde2 !important;
}
.routing-rule-actions .addconfigbtn.delete-btn:disabled .fa, .routing-rule-actions .addconfigbtn.delete-btn[disabled] .fa {
  color: #9aa8b3 !important;
}
.routing-rule-actions .addconfigbtn.delete-btn:hover:not(:disabled):not([disabled]) {
  background-color: #fff5f5 !important;
  border-color: #f5a8a8 !important;
}
.routing-rule-actions .addconfigbtn.delete-btn:hover:not(:disabled):not([disabled]) .fa {
  color: #c53030 !important;
}

.routing-empty-state-inline {
  padding: 10px 4px;
  font-size: 11px;
  color: #64748b;
  font-style: italic;
}

/* Rule Expression bar */
.routing-expression-bar {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  width: 100%;
  min-height: 36px;
  padding: 8px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  margin-top: 10px;
  box-sizing: border-box;
}

.routing-expression-bar--sticky {
  flex-shrink: 0;
  margin-top: 0;
  position: static;
  border-top: 1px solid #e2e8f0;
  border-radius: 0;
  box-shadow: none;
}

.routing-expression-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.routing-build-expr-btn {
  flex-shrink: 0;
}

.routing-expression-label {
  flex: 0 1 auto;
  min-width: 0;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
}
.routing-expression-label strong {
  font-weight: 1100;
}

.routing-expression-value {
  width: 100%;
  min-width: 0;
  max-height: 4.5em;
  overflow-x: hidden;
  overflow-y: auto;
  word-break: break-word;
  overflow-wrap: anywhere;
  font-size: 13px;
  color: #64748b;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  line-height: 1.5;
}

.routing-empty-state {
  padding: 24px 16px;
  font-size: 12px;
  color: #64748b;
  text-align: center;
  background-color: #f8fafc;
  border-radius: 8px;
  margin: 12px;
  border: 1px dashed #e2e8f0;
}

/*
 * Outlined mat-form-field: do NOT override .mat-mdc-form-field-infix padding or flex —
 * Material positions the value when the label floats; asymmetric padding (e.g. 8px/4px)
 * makes typed text ride up. Only tweak font + background + hide hint row.
 */
:host ::ng-deep {
  /* Force same visual shell as pipeline autocomplete for Field/Operator/Value/Pipeline controls */
  /* Default: label centered in box; on focus/value floats to notch (not floatLabel="always") */
  /* Chip Value: mat-form-field notched outline — see rule-value-inline-mat-field mixin */
}
:host ::ng-deep .routing-common-form .mat-mdc-form-field {
  font-size: 11px;
  background-color: #fff !important;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
:host ::ng-deep .routing-common-form .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: #fff !important;
  width: 100%;
}
:host ::ng-deep .routing-common-form .mat-mdc-form-field .mat-mdc-input-element,
:host ::ng-deep .routing-common-form .mat-mdc-form-field .mat-mdc-select-value {
  font-size: 11px !important;
}
:host ::ng-deep .routing-common-form .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field),
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field,
:host ::ng-deep .routing-common-form .routing-hl7-composite.mat-mdc-form-field,
:host ::ng-deep .routing-common-form .routing-pipeline.mat-mdc-form-field {
  margin: 0 !important;
  --mat-form-field-container-height: 36px;
  --mat-form-field-container-vertical-padding: 8px;
  --mdc-outlined-text-field-container-height: 36px;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mat-mdc-input-element,
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mat-mdc-select-value,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mat-mdc-input-element,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mat-mdc-select-value,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-input-element,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-select-value,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mat-mdc-input-element,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mat-mdc-select-value,
:host ::ng-deep .routing-common-form .routing-hl7-composite.mat-mdc-form-field .mat-mdc-input-element,
:host ::ng-deep .routing-common-form .routing-hl7-composite.mat-mdc-form-field .mat-mdc-select-value,
:host ::ng-deep .routing-common-form .routing-pipeline.mat-mdc-form-field .mat-mdc-input-element,
:host ::ng-deep .routing-common-form .routing-pipeline.mat-mdc-form-field .mat-mdc-select-value {
  font-size: 12px !important;
  line-height: 20px !important;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mdc-text-field--outlined,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mdc-text-field--outlined,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mdc-text-field--outlined,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mdc-text-field--outlined,
:host ::ng-deep .routing-common-form .routing-hl7-composite.mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-common-form .routing-hl7-composite.mat-mdc-form-field .mdc-text-field--outlined,
:host ::ng-deep .routing-common-form .routing-pipeline.mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-common-form .routing-pipeline.mat-mdc-form-field .mdc-text-field--outlined {
  min-height: 36px;
  height: 36px;
  border-radius: 4px;
  background: #ffffff !important;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mat-mdc-form-field-infix,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mat-mdc-form-field-infix,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-form-field-infix,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mat-mdc-form-field-infix,
:host ::ng-deep .routing-common-form .routing-hl7-composite.mat-mdc-form-field .mat-mdc-form-field-infix,
:host ::ng-deep .routing-common-form .routing-pipeline.mat-mdc-form-field .mat-mdc-form-field-infix {
  min-height: 36px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mat-mdc-select-trigger,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mat-mdc-select-trigger,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-select-trigger,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mat-mdc-select-trigger,
:host ::ng-deep .routing-common-form .routing-hl7-composite.mat-mdc-form-field .mat-mdc-select-trigger,
:host ::ng-deep .routing-common-form .routing-pipeline.mat-mdc-form-field .mat-mdc-select-trigger {
  min-height: 20px;
  height: 20px;
  align-items: center;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mdc-notched-outline__leading,
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mdc-notched-outline__notch,
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mdc-notched-outline__trailing,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mdc-notched-outline__leading,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mdc-notched-outline__notch,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mdc-notched-outline__trailing,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mdc-notched-outline__leading,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mdc-notched-outline__notch,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mdc-notched-outline__trailing,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mdc-notched-outline__leading,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mdc-notched-outline__notch,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mdc-notched-outline__trailing,
:host ::ng-deep .routing-common-form .routing-hl7-composite.mat-mdc-form-field .mdc-notched-outline__leading,
:host ::ng-deep .routing-common-form .routing-hl7-composite.mat-mdc-form-field .mdc-notched-outline__notch,
:host ::ng-deep .routing-common-form .routing-hl7-composite.mat-mdc-form-field .mdc-notched-outline__trailing,
:host ::ng-deep .routing-common-form .routing-pipeline.mat-mdc-form-field .mdc-notched-outline__leading,
:host ::ng-deep .routing-common-form .routing-pipeline.mat-mdc-form-field .mdc-notched-outline__notch,
:host ::ng-deep .routing-common-form .routing-pipeline.mat-mdc-form-field .mdc-notched-outline__trailing {
  border-color: #cfd8e3 !important;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field),
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field {
  overflow: visible !important;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mat-mdc-form-field-flex,
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mdc-text-field--outlined,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mat-mdc-form-field-flex,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mdc-text-field--outlined,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-form-field-flex,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mdc-text-field--outlined,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mat-mdc-form-field-flex,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mdc-text-field--outlined {
  overflow: visible !important;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mdc-floating-label:not(.mdc-floating-label--float-above),
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mdc-floating-label:not(.mdc-floating-label--float-above),
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mdc-floating-label:not(.mdc-floating-label--float-above),
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mdc-floating-label:not(.mdc-floating-label--float-above) {
  top: 50% !important;
  transform: translateY(-50%) !important;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mat-mdc-floating-label--float-above,
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field .mdc-floating-label--float-above,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mat-mdc-floating-label--float-above,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mdc-floating-label--float-above,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mat-mdc-floating-label--float-above,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) .mdc-floating-label--float-above,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mat-mdc-floating-label--float-above,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field .mdc-floating-label--float-above {
  top: -9px !important;
  transform: scale(0.75) !important;
  transform-origin: left top;
  background: #fff;
  padding: 0 4px;
  z-index: 1;
}
:host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field.mat-focused .mat-mdc-floating-label, :host ::ng-deep .routing-common-form .routing-field.mat-mdc-form-field.mat-focused .mdc-floating-label,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field.mat-focused .mat-mdc-floating-label,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field.mat-focused .mdc-floating-label,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field).mat-focused .mat-mdc-floating-label,
:host ::ng-deep .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field).mat-focused .mdc-floating-label,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field.mat-focused .mat-mdc-floating-label,
:host ::ng-deep .routing-common-form .routing-rulename.mat-mdc-form-field.mat-focused .mdc-floating-label {
  color: #0f766e !important;
}
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mat-mdc-select-value,
:host ::ng-deep .routing-common-form .routing-select-operator.mat-mdc-form-field .mat-mdc-select-value-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Version dropdown option styling (only latest item gets highlight colors) */
.rc-version-live {
  color: #2d862d;
  font-weight: 600;
  font-size: 12px;
}

.rc-version-devqc {
  color: #ff9900;
  font-weight: 600;
  font-size: 12px;
}

.rc-version-default {
  font-size: 12px;
}

.qc-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.qc-modal {
  width: 80%;
  max-width: 1000px;
  max-height: 85%;
  background: #fff;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.compare-modal {
  max-width: 95vw;
  width: 95vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.compare-header {
  border-bottom: 1px solid #dee2e6;
  padding: 10px 16px;
  background: #f8f9fa;
}

.compare-subtitle {
  font-weight: normal;
  color: #0d6efd;
  font-size: 0.9em;
}

.compare-body {
  padding: 14px 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.compare-version-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 0;
  margin-bottom: 12px;
}

.compare-version-field--left {
  justify-self: start;
  grid-column: 1;
}

.compare-version-field--right {
  justify-self: start;
  grid-column: 2;
}

.compare-version-field {
  flex: 0 1 auto;
  min-width: 160px;
  max-width: 280px;
  width: 100%;
  height: 44px;
}

:host ::ng-deep .compare-version-field .mat-mdc-text-field-wrapper {
  padding-top: 0;
  padding-bottom: 0;
  height: 40px;
}
:host ::ng-deep .compare-version-field .mat-mdc-form-field-infix {
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 40px;
}
:host ::ng-deep .compare-version-field .mat-mdc-floating-label,
:host ::ng-deep .compare-version-field mat-label {
  font-size: 13px;
}
:host ::ng-deep .compare-version-field .mat-mdc-select-value,
:host ::ng-deep .compare-version-field .mat-mdc-select-placeholder {
  font-size: 0.875rem;
}

.compare-diff-container {
  flex: 1;
  min-height: 400px;
}

.version-notes-modal {
  max-width: 90vw;
  width: 70vw;
}

.version-notes-header {
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
}

.version-notes-subtitle {
  font-weight: normal;
  color: #0d6efd;
  font-size: 0.9em;
}

.version-notes-body {
  max-height: 60vh;
  overflow-y: auto;
}

.version-notes-loading,
.version-notes-empty {
  text-align: center;
  padding: 24px;
}

.version-notes-list {
  padding-right: 6px;
}

/* Two-column layout — full-height vertical split */
.routing-main-split {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  align-items: stretch;
  gap: 0;
  padding: 0;
  border-top: 1px solid #e2e8f0;
}

.routing-pipeline-left {
  flex: 0 0 28%;
  width: 28%;
  max-width: 28%;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  overflow: hidden;
  border: none;
  border-right: 2px solid #cbd5e1;
  border-radius: 0;
  background: #fff;
  box-sizing: border-box;
  align-self: stretch;
}

.routing-left-pipeline-search-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin-bottom: 10px;
}

.routing-left-pipeline-search {
  flex: 1;
  min-width: 0;
  margin: 0;
}

.routing-left-pipeline-new-btn {
  flex-shrink: 0;
  white-space: nowrap;
  margin: 0;
  padding: 1px 6px;
  height: 30px;
  min-height: 30px;
  line-height: 1;
  font-size: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  box-sizing: border-box;
  align-self: center;
}
.routing-left-pipeline-new-btn .fa {
  font-size: 9px;
}

.routing-left-pipeline-autocomplete {
  width: 100%;
  min-width: 0;
  margin: 0;
}

:host ::ng-deep .routing-left-pipeline-autocomplete .ng-autocomplete {
  width: 100%;
  margin: 0;
}

:host ::ng-deep .routing-left-pipeline-autocomplete .autocomplete-container {
  width: 100%;
  box-sizing: border-box;
  margin: 0 !important;
  height: 36px !important;
  min-height: 36px !important;
  box-shadow: none !important;
  border-radius: 4px !important;
}

:host ::ng-deep .routing-left-pipeline-autocomplete .autocomplete-container .input-container {
  height: 36px !important;
  min-height: 36px !important;
}

:host ::ng-deep .routing-left-pipeline-autocomplete .autocomplete-container .input-container input {
  height: 34px !important;
  min-height: 34px !important;
  line-height: 34px !important;
  padding: 0 10px !important;
  border: none !important;
  box-shadow: none !important;
}

:host ::ng-deep .routing-left-pipeline-autocomplete .input-container {
  font-size: 12px;
  min-height: 36px;
  height: 36px;
  border: 1px solid #cfd8e3;
  border-radius: 4px;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0;
}

.routing-left-pipeline-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  margin-top: 4px;
  padding-top: 2px;
}

.routing-left-pipeline-item {
  width: 100%;
  text-align: left;
  border: 1px solid #b8e0dc;
  border-left: 3px solid #80cbc4;
  border-radius: 4px;
  background: white;
  padding: 5px 8px;
  font-size: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  box-sizing: border-box;
  transition: background-color 0.15s ease, border-color 0.15s ease, border-left-width 0.15s ease, box-shadow 0.15s ease;
}
.routing-left-pipeline-item:hover {
  background: #e0f7f5;
  border-color: #9dd9d2;
  border-left-color: #4db6ac;
}

.routing-left-pipeline-item--active {
  background: #e0f2f1;
  border-color: #80cbc4;
  border-left-width: 3px;
  border-left-color: #00796b;
}
.routing-left-pipeline-item--active:hover {
  background: #d4eeec;
  border-left-color: #00695c;
}

.routing-left-pipeline-item-label {
  font-size: 11px;
  font-weight: 600;
  line-height: 1.25;
  color: #00796b;
  word-break: break-word;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.routing-left-pipeline-item-meta {
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  color: #00897b;
}

.routing-left-pipeline-item--active .routing-left-pipeline-item-label {
  color: #00695c;
}

.routing-left-pipeline-item--active .routing-left-pipeline-item-meta {
  color: #00796b;
  font-weight: 600;
}

.routing-left-pipeline-total {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  padding-top: 6px;
  border-top: 1px solid #e2e8f0;
}

.routing-pipeline-right {
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
  max-width: none;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  background: #f9fafb;
  align-self: stretch;
}

.routing-pipeline-right > .routing-expression-bar,
.routing-pipeline-right > .routing-expression-bar--sticky {
  order: 3;
  flex-shrink: 0;
}

.routing-field-cell {
  flex: 46 1 0;
  min-width: 0;
}

.routing-field-cell--hl7,
.routing-field-cell--xml {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  min-width: 0;
}

.routing-xml-field-group {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
}

.routing-xml-field-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 8px;
  width: auto;
}

.routing-xml-field-row .routing-field {
  flex: 1 1 360px;
  width: min(100%, 520px);
  min-width: 320px;
  max-width: 520px;
  margin: 0 !important;
}

.routing-xml-build-path-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  padding-bottom: 0;
}

.routing-hl7-field-group {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
}

.routing-hl7-field-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 8px;
  width: auto;
}

.routing-hl7-field-block {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #cfd8e3;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
  flex: 0 0 auto;
}

.routing-hl7-field-block-label {
  position: absolute;
  top: -10px;
  left: 10px;
  z-index: 3;
  padding: 0 5px;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.1;
  color: rgba(0, 0, 0, 0.6);
  background: #fff;
  pointer-events: none;
  white-space: nowrap;
}

.routing-hl7-field-shell {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  width: max-content;
  height: 20px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.routing-hl7-build-path-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  padding-bottom: 0;
}

.routing-hl7-sep {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
  padding: 0;
  margin: 0;
  width: 0.35em;
}

.routing-hl7-segment-input {
  flex: 0 0 auto;
  width: 4.5ch;
  min-width: 3ch;
  max-width: 5ch;
  height: 20px;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  color: inherit;
  box-sizing: border-box;
}

.routing-hl7-index-input {
  flex: 0 0 auto;
  width: 2.5ch;
  min-width: 1.5ch;
  max-width: 2.5ch;
  height: 20px;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: inherit;
  box-sizing: border-box;
}

.routing-hl7-index-input::placeholder,
.routing-hl7-segment-input::placeholder {
  color: rgba(0, 0, 0, 0.38);
}

.routing-empty-pipelines {
  margin: 16px 20px;
}

.routing-compact-row.routing-rule-part-1 {
  flex-wrap: nowrap;
  align-items: center;
}

.routing-rulename-cell {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.routing-rulename-cell .routing-rulename {
  width: 100%;
  box-sizing: border-box;
}

/* XML/HL7 field inside grid column — must not steal width on edit */
.routing-rule-part-1 > .routing-field-cell,
.routing-rule-part-1 > .routing-field-cell--xml {
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow: visible;
}

.routing-rule-part-1 > .routing-field-cell--hl7 {
  min-width: 0;
  width: auto;
  max-width: none;
  overflow: visible;
}

.routing-rule-part-1 .routing-xml-field-group,
.routing-rule-part-1:not(.routing-rule-part-1--hl7) .routing-hl7-field-group {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.routing-rule-part-1 .routing-xml-field-row,
.routing-rule-part-1:not(.routing-rule-part-1--hl7) .routing-hl7-field-row {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.routing-rule-part-1 .routing-xml-field-row .routing-field {
  flex: 1 1 0;
  width: 100%;
  min-width: 0 !important;
  max-width: 100% !important;
}
.routing-rule-part-1 .routing-xml-field-row .routing-field .mat-mdc-input-element {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.routing-value-col .rule-value-inline-field.mat-mdc-form-field {
  margin-top: 0;
}

.routing-selected-pipeline-header {
  cursor: default;
}

/* Segment autocomplete — panel wider than narrow input trigger */
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.routing-hl7-segment-autocomplete-panel {
  min-width: 160px !important;
  width: auto !important;
  max-width: 240px !important;
}

::ng-deep .cdk-overlay-container .routing-hl7-segment-autocomplete-panel .mat-mdc-option {
  min-height: 36px;
  padding: 0 12px;
  font-size: 12px;
  white-space: nowrap;
}

/* mat-select — see routing-mat-select-overlay.util.ts */
::ng-deep body.routing-mat-select-open .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  pointer-events: none !important;
}

::ng-deep .mat-mdc-select-panel.routing-mat-select-panel {
  z-index: 10001 !important;
}

:host {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

.routing-dialog-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.routing-ruleconfig-container {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/routing-ruleconfig1/routing-ruleconfig1.component.scss","webpack://./src/app/routing-ruleconfig1/routing-ruleconfig-shared.styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,8CAAA;AAOA,yFAAA;AASA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;ADZF;;ACeA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;ADZF;;ACeA;EACE,WAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,yBArCgB;ADyBlB;;ACeA,uCAAA;AACA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAtC2B;EAuC3B,0EAAA;EAMA,gCAAA;EACA,uFAAA;ADjBF;;ACoBA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cArD2B;EAsD3B,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;ADjBF;;ACoBA;EACE,2CAAA;EACA,cA/DmC;AD8CrC;;ACmBA;EACE,YAAA;ADhBF;;ACmBA;EACE,OAAA;ADhBF;;ACmBA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;ADhBF;;ACoBE;EAAsB,eAAA;ADhBxB;ACiBE;EACE,mBA9Fc;EA+Fd,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,4CAAA;ADfJ;ACiBE;EACE,2BAAA;EACA,8BAAA;EACA,2BAAA;ADfJ;ACiBE;EAAwC,wBAAA;ADd1C;ACeE;;EAEE,yBAAA;EACA,0BAAA;ADbJ;;ACiBA,qCAAA;AACA;EACE,QAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ADdF;;ACiBA;EACE,cAAA;EACA,gBAAA;ADdF;;ACiBA,iDAAA;AACA;EACE,cAAA;EACA,SAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EAEA,6DAAA;EACA,sBAAA;ADfF;;ACkBA,6EAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;ADfF;;ACkBA,4EAAA;AACA;EACE,aAAA;EACA,sEAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;ADfF;;ACkBA;;;;EAIE,YAAA;EACA,WAAA;EACA,eAAA;ADfF;;ACkBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;ADfF;;ACkBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;ADfF;;ACkBA;;EAEE,WAAA;EACA,YAAA;EACA,sBAAA;ADfF;;ACkBA;EACE,iBAAA;ADfF;;ACkBA,4EAAA;AACA;EACE,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;ADfF;;ACkBA;EACE,uBAAA;ADfF;;ACkBA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;ADfF;;ACkBA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;ADfF;;ACkBA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;ADfF;;ACkBA;;EAEE,WAAA;EACA,eAAA;ADfF;;ACoBI;;EAEE,oBAAA;EACA,iCAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;ADjBN;ACoBI;;EAEE,gBAAA;EACA,YAAA;ADlBN;ACqBI;EACE,2BAAA;EACA,2BAAA;EACA,8BAAA;ADnBN;ACsBI;EACE,gBAAA;EACA,YAAA;ADpBN;ACyBI;;EAEE,gBAAA;EACA,YAAA;ADvBN;;AC4BA;EACE,WAAA;EACA,SAAA;ADzBF;;AC4BA;EACE,mBAAA;ADzBF;;AC4BA,wEAAA;AACA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;ADzBF;;AC4BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;ADzBF;;AC4BA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;ADzBF;;AC4BA;EACE,WAAA;EACA,YAAA;EACA,WAAA;ADzBF;;AC4BA,iCAAA;AACA;EACE,aAAA;EACA,sEAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;ADzBF;;AC4BA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;ADzBF;;AC4BA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;ADzBF;;AC4BA;EACE,WAAA;ADzBF;;AC4BA,gEAAA;AACA;EACE,WAAA;EACA,YAAA;ADzBF;;AC4BA;EACE,WAAA;ADzBF;;AC4BA;EACE,WAAA;EACA,sBAAA;ADzBF;;AC4BA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;ADzBF;;AC4BA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,sBAAA;ADzBF;;AC4BA;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ADzBF;;AC4BA;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,6DAAA;EACA,6BAAA;EACA,gDAAA;ADzBF;;AC4BA;EACE,OAAA;ADzBF;;AC4BA;EACE,eAAA;EACA,iBAAA;EACA,8CAAA;ADzBF;;AC4BA;EACE,2BAAA;EACA,8CAAA;ADzBF;;AC4BA,mDAAA;AACA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;ADzBF;;AC4BA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,8EAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;ADzBF;;AC4BA;EACE,OAAA;EACA,aAAA;ADzBF;;AC4BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBA1boB;EA2bpB,YAAA;EACA,8BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,4FAAA;ADzBF;;AC4BA;EACE,mBAAA;EACA,0BAAA;ADzBF;;AC4BA;EACE,mBAAA;EACA,0BA7ce;EA8cf,mDAAA;ADzBF;;AC4BA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;ADzBF;;AC4BA;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ADzBF;;AC4BA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ADzBF;;AC4BA;EACE,eAAA;EACA,gBAAA;EACA,cA7ec;ADodhB;;AC4BA;EACE,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;ADzBF;AC2BE;EACE,mBAAA;EACA,qBAAA;ADzBJ;;AC6BA;EACE,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AD1BF;AC4BE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AD1BJ;;AC8BA;EACE,4BAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,yBA/hBgB;EAgiBhB,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;AD3BF;;AC8BA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AD3BF;;AC8BA;EACE,yBAAA;AD3BF;;AC8BA,iBAAA;AACA;EACE,WAAA;EACA,kBAAA;AD3BF;;AC8BA;;EAEE,cAAA;EACA,eAAA;EACA,WAAA;AD3BF;;AC8BA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AD3BF;;AC8BA;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,sBAAA;EACA,qBAAA;AD3BF;;AC8BA,mFAAA;AACA;EACE,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;AD3BF;;AC8BA;EACE,cAAA;AD3BF;;AC8BA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AD3BF;;AC8BA;EACE,4BAAA;EACA,kBAAA;EACA,uFAAA;EACA,yBAnmBgB;EAomBhB,yBAAA;AD3BF;;AC8BA;EACE,yBAAA;EACA,qBAAA;EACA,4CAAA;AD3BF;;AC8BA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AD3BF;;AC8BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AD3BF;;AC8BA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AD3BF;;AC8BA;EACE,YAAA;AD3BF;;AC8BA;EACE,0BAAA;EACA,cAAA;AD3BF;;AC8BA,wBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AD3BF;;AC8BA;;;EAAA;AAIA;;EAEE,oCAAA;EACA,oCAAA;EACA,2BAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,4CAAA;EACA,kFAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;AD3BF;AC6BE;;EACE,0BAAA;EACA,yBAAA;AD1BJ;;AC8BA;EACE,yBAAA;AD3BF;AC6BE;EACE,yBAAA;AD3BJ;AC8BE;EACE,oCAAA;EACA,gCAAA;AD5BJ;;ACgCA;EACE,yBAAA;AD7BF;AC+BE;EACE,yBAAA;AD7BJ;ACgCE;EAEE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,oCAAA;EACA,gCAAA;AD/BJ;ACiCI;EACE,yBAAA;AD/BN;ACmCE;EACE,oCAAA;EACA,gCAAA;ADjCJ;ACmCI;EACE,yBAAA;ADjCN;;ACsCA;EACE,iBAAA;EACA,eAAA;EACA,cA3tBc;EA4tBd,kBAAA;ADnCF;;ACsCA,wBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;ADnCF;;ACsCA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;ADnCF;;ACsCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;ADnCF;;ACsCA;EACE,cAAA;ADnCF;;ACsCA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ADnCF;ACqCE;EACE,iBAAA;ADnCJ;;ACuCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,cA1xBc;EA2xBd,6EAAA;EACA,gBAAA;ADpCF;;ACuCA;EACE,kBAAA;EACA,eAAA;EACA,cAlyBc;EAmyBd,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,0BAAA;ADpCF;;ACuCA;;;;EAAA;AAKA;EAuBE,gGAAA;EA6CA,6FAAA;EA2CA,uFAAA;ADhJF;ACkCE;EACE,eAAA;EACA,iCAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;ADhCJ;ACkCI;EACE,iCAAA;EACA,WAAA;ADhCN;ACmCI;;EAEE,0BAAA;ADjCN;ACoCI;EACE,wBAAA;ADlCN;ACuCE;;;;;;EAME,oBAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;ADrCJ;ACuCI;;;;;;;;;;;;EAEE,0BAAA;EACA,4BAAA;AD3BN;AC8BI;;;;;;;;;;;;EAEE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;ADlBN;ACqBI;;;;;;EACE,2BAAA;EACA,2BAAA;EACA,8BAAA;ADdN;ACiBI;;;;;;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;ADVN;ACaI;;;;;;;;;;;;;;;;;;EAGE,gCAAA;ADIN;ACCE;;;;EAIE,4BAAA;ADCJ;ACCI;;;;;;;;;;;;EAGE,4BAAA;ADUN;ACPI;;;;EACE,mBAAA;EACA,sCAAA;ADYN;ACTI;;;;;;;;EAEE,oBAAA;EACA,iCAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;ADiBN;ACdI;;;;;;;EAEE,yBAAA;ADqBN;AChBI;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;ADkBN;;ACXA,6EAAA;AACA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;ADcF;;ACXA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;ADcF;;ACXA;EACE,eAAA;ADcF;;ACXA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;ADcF;;ACXA;EACE,UAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;ADcF;;ACXA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ADcF;;ACXA;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;ADcF;;ACXA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;ADcF;;ACXA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;ADcF;;ACXA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,MAAA;EACA,mBAAA;ADcF;;ACXA;EACE,mBAAA;EACA,cAAA;ADcF;;ACXA;EACE,mBAAA;EACA,cAAA;ADcF;;ACXA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;ADcF;;ACVE;EACE,cAAA;EACA,iBAAA;EACA,YAAA;ADaJ;ACVE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;ADYJ;ACTE;;EAEE,eAAA;ADWJ;ACRE;;EAEE,mBAAA;ADUJ;;ACNA;EACE,OAAA;EACA,iBAAA;ADSF;;ACNA;EACE,eAAA;EACA,WAAA;ADSF;;ACNA;EACE,gCAAA;EACA,mBAAA;ADSF;;ACNA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;ADSF;;ACNA;EACE,gBAAA;EACA,gBAAA;ADSF;;ACNA;;EAEE,kBAAA;EACA,aAAA;ADSF;;ACNA;EACE,kBAAA;ADSF;;ACPA,mDAAA;AACA;EACE,aAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,MAAA;EACA,UAAA;EACA,6BAAA;ADUF;;ACPA;EACE,aAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;ADUF;;ACPA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;ADUF;;ACPA;EACE,OAAA;EACA,YAAA;EACA,SAAA;ADUF;;ACPA;EACE,cAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;ADUF;ACRE;EACE,cAAA;ADUJ;;ACNA;EACE,WAAA;EACA,YAAA;EACA,SAAA;ADSF;;ACNA;EACE,WAAA;EACA,SAAA;ADSF;;ACNA;EACE,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;ADSF;;ACNA;EACE,uBAAA;EACA,2BAAA;ADSF;;ACNA;EACE,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;ADSF;;ACNA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;ADSF;;ACNA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,OAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;ADSF;;ACNA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,sBAAA;EACA,qHACE;ADQJ;ACHE;EACE,mBAAA;EACA,qBAAA;EACA,0BAAA;ADKJ;;ACAA;EACE,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,0BAAA;ADGF;ACDE;EACE,mBAAA;EACA,0BAAA;ADGJ;;ACCA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;ADEF;;ACCA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;ADEF;;ACCA;EACE,cAAA;ADEF;;ACCA;EACE,cAAA;EACA,gBAAA;ADEF;;ACCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAhwCc;EAiwCd,gBAAA;EACA,6BAAA;ADEF;;ACCA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;ADEF;;ACCA;;EAEE,QAAA;EACA,cAAA;ADEF;;ACCA;EAAsB,YAAA;EAAc,YAAA;ADIpC;;ACHA;;EAEE,cAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;ADMF;;ACJA;EACE,cAAA;EACA,WAAA;EACA,YAAA;ADOF;;ACLA;EACE,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;ADQF;;ACNA;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;ADSF;;ACPA;EACE,cAAA;EACA,aAAA;EACA,qBAAA;EACA,iBAAA;ADUF;;ACRA;EACE,cAAA;EACA,WAAA;EACA,YAAA;ADWF;;ACTA;EACE,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;ADYF;;ACVA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;ADaF;;ACVA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;ADaF;;ACVA;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,MAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;ADaF;;ACXA;EACE,cAAA;EACA,aAAA;EACA,qBAAA;EACA,iBAAA;ADcF;;ACZA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;ADeF;;ACZA;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;ADeF;;ACZA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;ADeF;;ACZA;;EAEE,0BAAA;ADeF;;ACZA;EAA2B,iBAAA;ADgB3B;;ACfA;EAA2C,iBAAA;EAAmB,mBAAA;ADoB9D;;ACnBA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;ADsBF;;ACpBA;EAA2C,WAAA;EAAa,sBAAA;ADyBxD;;ACvBA,oEAAA;AACA;;EAEE,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AD0BF;;ACvBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AD0BF;;ACvBA;;EAEE,WAAA;EACA,YAAA;EACA,eAAA;AD0BF;;ACvBA;;EAEE,WAAA;EACA,YAAA;EACA,eAAA;AD0BF;;ACvBA;EACE,WAAA;EACA,WAAA;EACA,uBAAA;EACA,0BAAA;AD0BF;ACxBE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AD0BJ;;ACtBA;EACE,aAAA;ADyBF;;ACvBA;EAAoC,eAAA;AD2BpC;;ACzBA,iEAAA;AACA;EACE,2BAAA;EACA,sBAAA;EACA,2BAAA;AD4BF;;ACzBA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AD4BF;;ACzBA,wDAAA;AACA;EAEE,+BAAA;AD2BF;;ACxBA;EACE,yBAAA;AD2BF;;AAthDA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;AAyhDF;;AAthDA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAyhDF;;AAthDA;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAyhDF","sourcesContent":["@import './routing-ruleconfig-shared.styles.scss';\r\n\r\n:host {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  height: 100%;\r\n}\r\n\r\n.routing-dialog-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.routing-ruleconfig-container {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n","/* Restrained palette — readable, not flashy */\r\n$routing-surface: #ffffff;\r\n$routing-muted: #64748b;\r\n$routing-border: #e2e8f0;\r\n$routing-accent: #0f766e;\r\n$routing-accent-soft: #ecfdf5;\r\n\r\n/* Header strip only — cool sky/slate + blue accent (matches blue/teal UI, no red/warm) */\r\n$routing-header-strip-start: #f8fafc;\r\n$routing-header-strip-mid: #f0f9ff;\r\n$routing-header-strip-end: #e0f2fe;\r\n$routing-header-strip-border: #bae6fd;\r\n$routing-header-strip-accent: #2563eb;\r\n$routing-header-strip-accent-strong: #1d4ed8;\r\n$routing-header-strip-title: #0f172a;\r\n\r\n:host {\r\n  display: block;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.routing-dialog-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.routing-ruleconfig-container {\r\n  width: 100%;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  font-size: 12px;\r\n  background-color: $routing-surface;\r\n}\r\n\r\n/* Header — subtle depth, clear title */\r\n.rule-builder-header {\r\n  flex-shrink: 0;\r\n  min-height: auto;\r\n  width: 100%;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  padding: 12px 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  color: $routing-header-strip-title;\r\n  background: linear-gradient(\r\n    180deg,\r\n    $routing-header-strip-start 0%,\r\n    $routing-header-strip-mid 45%,\r\n    $routing-header-strip-end 100%\r\n  );\r\n  border-bottom: 1px solid $routing-header-strip-border;\r\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.95) inset, 0 2px 10px rgba(37, 99, 235, 0.09);\r\n}\r\n\r\n.routing-page-heading {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  letter-spacing: -0.02em;\r\n  color: $routing-header-strip-title;\r\n  border-left: 4px solid $routing-header-strip-accent;\r\n  padding-left: 12px;\r\n  line-height: 1.3;\r\n  text-shadow: 0 0 0 transparent;\r\n}\r\n\r\n.rule-builder-header .btn_style {\r\n  background-color: rgba(255, 255, 255, 0.95);\r\n  color: $routing-header-strip-accent-strong;\r\n}\r\n.rule-builder-header .btn_style:disabled {\r\n  opacity: 0.5;\r\n}\r\n\r\n.rule-builder-title-row {\r\n  flex: 1;\r\n}\r\n\r\n.rule-builder-version-field {\r\n  flex: 0 0 auto;\r\n  min-width: 160px;\r\n  max-width: 260px;\r\n}\r\n\r\n:host ::ng-deep .rule-builder-header .rule-builder-version-field {\r\n  .mat-mdc-form-field { font-size: 12px; }\r\n  .mat-mdc-text-field-wrapper {\r\n    background: $routing-surface;\r\n    border-radius: 6px;\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n    height: 36px;\r\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\r\n  }\r\n  .mat-mdc-form-field-infix {\r\n    padding-top: 6px !important;\r\n    padding-bottom: 6px !important;\r\n    min-height: 36px !important;\r\n  }\r\n  .mat-mdc-form-field-subscript-wrapper { display: none !important; }\r\n  .mat-mdc-select-value,\r\n  .mat-mdc-floating-label {\r\n    color: $routing-header-strip-accent-strong !important;\r\n    font-size: 12px !important;\r\n  }\r\n}\r\n\r\n/* Rules list — top of right column */\r\n.routing-body {\r\n  order: 2;\r\n  background-color: #f9fafb;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.routing-body > .routing-expression-bar {\r\n  flex-shrink: 0;\r\n  margin-top: auto;\r\n}\r\n\r\n/* Rule build form — directly under rules table */\r\n.routing-common-form {\r\n  flex-shrink: 0;\r\n  margin: 0;\r\n  padding: 8px 12px 6px;\r\n  border: none;\r\n  border-radius: 0;\r\n  //border-bottom: 1px solid $routing-border;\r\n  background: linear-gradient(180deg, #fafbfc 0%, #f1f5f9 100%);\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Inner form shell — same idea as create-rules-container + part-1 / part-2 */\r\n.routing-rules-form-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  overflow: visible;\r\n}\r\n\r\n/* Grid 46:14:36 — same as Rule Config; columns stay fixed on add and edit */\r\n.routing-rule-part-1 {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 46fr) minmax(0, 14fr) minmax(0, 36fr);\r\n  gap: 6px;\r\n  align-items: start;\r\n  width: 100%;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.routing-rule-part-1 > .routing-field-cell,\r\n.routing-rule-part-1 > .routing-select-operator,\r\n.routing-rule-part-1 > .routing-value,\r\n.routing-rule-part-1 > .routing-value-col {\r\n  min-width: 0;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.routing-field {\r\n  width: 100%;\r\n  min-width: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.routing-select-operator {\r\n  width: 100%;\r\n  min-width: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.routing-value,\r\n.routing-value-col {\r\n  width: 100%;\r\n  min-width: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.routing-rule-part-1--has-value-chips {\r\n  overflow: visible;\r\n}\r\n\r\n/* HL7: field shrink-wrap, operator fixed width, value fills remaining row */\r\n.routing-rule-part-1--hl7 {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: flex-end;\r\n  gap: 6px;\r\n  width: 100%;\r\n}\r\n\r\n.routing-rule-part-1--hl7.routing-rule-part-1--has-value-chips {\r\n  align-items: flex-start;\r\n}\r\n\r\n.routing-rule-part-1--hl7 > .routing-field-cell--hl7 {\r\n  flex: 0 0 auto;\r\n  width: auto;\r\n  max-width: none;\r\n  justify-self: auto;\r\n}\r\n\r\n.routing-rule-part-1--hl7 > .routing-select-operator {\r\n  flex: 0 0 112px;\r\n  width: 112px;\r\n  min-width: 112px;\r\n  max-width: 112px;\r\n}\r\n\r\n.routing-rule-part-1--hl7 > .routing-value-col,\r\n.routing-rule-part-1--hl7 > .routing-value.mat-mdc-form-field {\r\n  flex: 1 1 0;\r\n  min-width: 120px;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.routing-rule-part-1--hl7 .routing-hl7-field-group,\r\n.routing-rule-part-1--hl7 .routing-hl7-field-row {\r\n  width: auto;\r\n  max-width: none;\r\n}\r\n\r\n:host ::ng-deep .routing-rule-part-1--hl7 {\r\n  .routing-select-operator.mat-mdc-form-field:not(.rule-value-inline-field) {\r\n    .mat-mdc-floating-label,\r\n    .mdc-floating-label {\r\n      top: -9px !important;\r\n      transform: scale(0.75) !important;\r\n      transform-origin: left top;\r\n      background: #fff;\r\n      padding: 0 4px;\r\n      z-index: 1;\r\n    }\r\n\r\n    .mat-mdc-text-field-wrapper,\r\n    .mdc-text-field--outlined {\r\n      min-height: 36px;\r\n      height: 36px;\r\n    }\r\n\r\n    .mat-mdc-form-field-infix {\r\n      min-height: 36px !important;\r\n      padding-top: 8px !important;\r\n      padding-bottom: 8px !important;\r\n    }\r\n\r\n    .mat-mdc-select-trigger {\r\n      min-height: 20px;\r\n      height: 20px;\r\n    }\r\n  }\r\n\r\n  .routing-value.mat-mdc-form-field:not(.rule-value-inline-field) {\r\n    .mat-mdc-text-field-wrapper,\r\n    .mdc-text-field--outlined {\r\n      min-height: 36px;\r\n      height: 36px;\r\n    }\r\n  }\r\n}\r\n\r\n.routing-value-col .rule-value-inline-field.mat-mdc-form-field {\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.routing-rule-part-2--has-value-chips {\r\n  align-items: center;\r\n}\r\n\r\n/* HL7 part-2: align Rule Name under field, buttons under value column */\r\n.routing-rule-part-2--hl7 {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: center;\r\n  gap: 6px;\r\n  width: 100%;\r\n}\r\n\r\n.routing-rule-part-2--hl7 > .routing-rulename-cell {\r\n  flex: 0 0 auto;\r\n  width: auto;\r\n  min-width: 0;\r\n  max-width: none;\r\n}\r\n\r\n.routing-rule-part-2--hl7 > .routing-part-2-operator-spacer {\r\n  flex: 0 0 112px;\r\n  width: 112px;\r\n  min-width: 112px;\r\n  max-width: 112px;\r\n}\r\n\r\n.routing-rule-part-2--hl7 > .routing-form-actions {\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n  width: 100%;\r\n}\r\n\r\n/* Same 46:14:36 grid as part-1 */\r\n.routing-rule-part-2 {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 46fr) minmax(0, 14fr) minmax(0, 36fr);\r\n  gap: 6px;\r\n  align-items: center;\r\n  width: 100%;\r\n  padding: 0;\r\n  margin-top: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.routing-pipeline-cell {\r\n  min-width: 0;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.routing-part-2-operator-spacer {\r\n  min-width: 0;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.routing-pipeline {\r\n  width: 100%;\r\n}\r\n\r\n/* Pipeline ng-autocomplete — align with create pipeline field */\r\n.routing-pipeline-autocomplete {\r\n  width: 100%;\r\n  min-width: 0;\r\n}\r\n\r\n:host ::ng-deep .routing-pipeline-autocomplete .ng-autocomplete {\r\n  width: 100%;\r\n}\r\n\r\n:host ::ng-deep .routing-pipeline-autocomplete .autocomplete-container {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n:host ::ng-deep .routing-pipeline-autocomplete .input-container {\r\n  font-size: 12px;\r\n  min-height: 36px;\r\n  height: 36px;\r\n  border: 1px solid #cfd8e3;\r\n  border-radius: 4px;\r\n  background: #ffffff;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 10px;\r\n}\r\n\r\n.routing-form-actions {\r\n  display: flex;\r\n  width: 100%;\r\n  min-width: 0;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 6px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.add-or-edit-button,\r\n.clear-button {\r\n  color: #ffffff;\r\n  font-size: 10px;\r\n  padding: 1px 8px;\r\n  min-height: 26px;\r\n}\r\n\r\n.routing-footer {\r\n  flex-shrink: 0;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 12px 20px;\r\n  box-sizing: border-box;\r\n  background: linear-gradient(180deg, #f0fdfa 0%, #e6f7f3 100%);\r\n  border-top: 1px solid #bfe6dd;\r\n  box-shadow: 0 -2px 10px rgba(15, 118, 110, 0.08);\r\n}\r\n\r\n.routing-footer-spacer {\r\n  flex: 1;\r\n}\r\n\r\n.routing-footer-btn {\r\n  font-size: 11px;\r\n  padding: 4px 12px;\r\n  box-shadow: 0 1px 2px rgba(15, 118, 110, 0.18);\r\n}\r\n\r\n.routing-footer-btn:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 3px 8px rgba(15, 118, 110, 0.22);\r\n}\r\n\r\n/* Pipeline accordion — fills top of right column */\r\n.pipeline-accordion {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 12px 16px 8px 16px;\r\n  background-color: #f9fafb;\r\n}\r\n\r\n.pipeline-parent {\r\n  margin-bottom: 10px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  border: 1px solid $routing-border;\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 2px rgba(15, 23, 42, 0.04);\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.pipeline-parent.pipeline-expanded {\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.pipeline-parent-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px 14px;\r\n  background: $routing-accent-soft;\r\n  border: none;\r\n  border-left: 3px solid $routing-accent;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n  color: #115e59;\r\n  transition: background-color 0.15s ease, border-left-color 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.pipeline-parent-header:hover {\r\n  background: #d1fae5;\r\n  border-left-color: #0d9488;\r\n}\r\n\r\n.pipeline-parent-header.expanded {\r\n  background: #ccfbf1;\r\n  border-left-color: $routing-accent;\r\n  box-shadow: inset 0 -1px 0 rgba(15, 118, 110, 0.08);\r\n}\r\n\r\n.pipeline-chevron {\r\n  width: 18px;\r\n  margin-right: 6px;\r\n  flex-shrink: 0;\r\n  font-size: 11px;\r\n}\r\n\r\n.pipeline-label-text {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.pipeline-label-copy {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n}\r\n\r\n.pipeline-rule-count {\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  color: $routing-muted;\r\n}\r\n\r\n.pipeline-add-rule-btn {\r\n  margin-right: 8px;\r\n  border: 1px solid #7dd3c9;\r\n  background: #f0fdfa;\r\n  color: #0f766e;\r\n  border-radius: 4px;\r\n  font-size: 10px;\r\n  line-height: 1;\r\n  padding: 3px 7px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    background: #ccfbf1;\r\n    border-color: #14b8a6;\r\n  }\r\n}\r\n\r\n.pipeline-delete-block-btn {\r\n  margin-right: 8px;\r\n  border: 1px solid #cbd5e1;\r\n  background: #f8fafc;\r\n  color: #64748b;\r\n  border-radius: 4px;\r\n  font-size: 10px;\r\n  line-height: 1;\r\n  padding: 3px 7px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    background: #fef2f2;\r\n    border-color: #fca5a5;\r\n    color: #b91c1c;\r\n  }\r\n}\r\n\r\n.pipeline-children {\r\n  padding: 12px 14px 14px 14px;\r\n  border: none;\r\n  border-top: 1px solid #e2e8f0;\r\n  border-radius: 0;\r\n  background-color: $routing-surface;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.pipeline-children-scroll {\r\n  flex: 1 1 auto;\r\n  min-height: 120px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.pipeline-parent.pipeline-expanded .pipeline-children {\r\n  background-color: #fafafa;\r\n}\r\n\r\n/* Table header */\r\n.rule-display-header {\r\n  width: 100%;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.rule-display-header .row,\r\n.routing-rules-list .routing-rule-row .row {\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n  width: 100%;\r\n}\r\n\r\n.rule-display-header-sub-1 {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.routing-header-cell {\r\n  color: #ffffff !important;\r\n  font-size: 11px !important;\r\n  font-weight: 600 !important;\r\n  letter-spacing: 0.02em;\r\n  padding: 0 !important;\r\n}\r\n\r\n/* Brighter teal (matches earlier rule-builder look) — not the dark pine gradient */\r\n.rule-display-header .rule-display-header-sub-1 {\r\n  background-color: #0da7ad;\r\n  border-radius: 3px 3px 0 0;\r\n  padding: 4px 6px;\r\n  box-shadow: none;\r\n}\r\n\r\n.rule-display-header .cardContect {\r\n  color: #ffffff;\r\n}\r\n\r\n.routing-rules-list {\r\n  min-height: 48px;\r\n  max-height: none;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.routing-rule-row {\r\n  padding: 8px 10px !important;\r\n  border-radius: 6px;\r\n  transition: background-color 0.12s ease, border-color 0.12s ease, box-shadow 0.12s ease;\r\n  background-color: $routing-surface;\r\n  border: 1px solid #e8ecf0;\r\n}\r\n\r\n.routing-rule-row:hover {\r\n  background-color: #f0fdfa;\r\n  border-color: #99f6e4;\r\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.routing-rule-row .cardContect {\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  font-size: 11px;\r\n  color: #334155;\r\n}\r\n\r\n.rule-name-cell {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  max-width: 100%;\r\n}\r\n\r\n.rule-in-expression-icon {\r\n  color: #16a34a;\r\n  font-size: 14px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.routing-copyable-cell {\r\n  cursor: copy;\r\n}\r\n\r\n.routing-copyable-cell:hover {\r\n  text-decoration: underline;\r\n  color: #0f766e;\r\n}\r\n\r\n/* Edit / Delete icons */\r\n.routing-rule-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n/*\r\n * Global .addconfigbtn (VSstyles) forces teal bg + white text; icons often stay dark.\r\n * Override here so row actions stay light with readable icons.\r\n */\r\n.routing-rule-actions .addconfigbtn.edit_btn,\r\n.routing-rule-actions .addconfigbtn.delete-btn {\r\n  background-color: #ffffff !important;\r\n  border: 1px solid #b8d4da !important;\r\n  padding: 3px 6px !important;\r\n  min-width: 26px !important;\r\n  min-height: 26px !important;\r\n  height: auto !important;\r\n  line-height: 1 !important;\r\n  font-size: 12px;\r\n  border-radius: 4px;\r\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\r\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n\r\n  .fa {\r\n    font-size: 15px !important;\r\n    line-height: 1 !important;\r\n  }\r\n}\r\n\r\n.routing-rule-actions .addconfigbtn.edit_btn {\r\n  color: #0da7ad !important;\r\n\r\n  .fa {\r\n    color: #0da7ad !important;\r\n  }\r\n\r\n  &:hover {\r\n    background-color: #e0f7f7 !important;\r\n    border-color: #0da7ad !important;\r\n  }\r\n}\r\n\r\n.routing-rule-actions .addconfigbtn.delete-btn {\r\n  color: #5a6b7a !important;\r\n\r\n  .fa {\r\n    color: #5a6b7a !important;\r\n  }\r\n\r\n  &:disabled,\r\n  &[disabled] {\r\n    opacity: 0.45;\r\n    cursor: not-allowed !important;\r\n    pointer-events: none;\r\n    background-color: #f1f5f6 !important;\r\n    border-color: #d0dde2 !important;\r\n\r\n    .fa {\r\n      color: #9aa8b3 !important;\r\n    }\r\n  }\r\n\r\n  &:hover:not(:disabled):not([disabled]) {\r\n    background-color: #fff5f5 !important;\r\n    border-color: #f5a8a8 !important;\r\n\r\n    .fa {\r\n      color: #c53030 !important;\r\n    }\r\n  }\r\n}\r\n\r\n.routing-empty-state-inline {\r\n  padding: 10px 4px;\r\n  font-size: 11px;\r\n  color: $routing-muted;\r\n  font-style: italic;\r\n}\r\n\r\n/* Rule Expression bar */\r\n.routing-expression-bar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  gap: 6px;\r\n  width: 100%;\r\n  min-height: 36px;\r\n  padding: 8px 12px;\r\n  background: #f8fafc;\r\n  border: 1px solid $routing-border;\r\n  border-radius: 6px;\r\n  margin-top: 10px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.routing-expression-bar--sticky {\r\n  flex-shrink: 0;\r\n  margin-top: 0;\r\n  position: static;\r\n  border-top: 1px solid $routing-border;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.routing-expression-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  width: 100%;\r\n  min-width: 0;\r\n}\r\n\r\n.routing-build-expr-btn {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.routing-expression-label {\r\n  flex: 0 1 auto;\r\n  min-width: 0;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #475569;\r\n\r\n  strong {\r\n    font-weight: 1100;\r\n  }\r\n}\r\n\r\n.routing-expression-value {\r\n  width: 100%;\r\n  min-width: 0;\r\n  max-height: 4.5em;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  word-break: break-word;\r\n  overflow-wrap: anywhere;\r\n  font-size: 13px;\r\n  color: $routing-muted;\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\r\n  line-height: 1.5;\r\n}\r\n\r\n.routing-empty-state {\r\n  padding: 24px 16px;\r\n  font-size: 12px;\r\n  color: $routing-muted;\r\n  text-align: center;\r\n  background-color: #f8fafc;\r\n  border-radius: 8px;\r\n  margin: 12px;\r\n  border: 1px dashed $routing-border;\r\n}\r\n\r\n/*\r\n * Outlined mat-form-field: do NOT override .mat-mdc-form-field-infix padding or flex —\r\n * Material positions the value when the label floats; asymmetric padding (e.g. 8px/4px)\r\n * makes typed text ride up. Only tweak font + background + hide hint row.\r\n */\r\n:host ::ng-deep {\r\n  .routing-common-form .mat-mdc-form-field {\r\n    font-size: 11px;\r\n    background-color: #fff !important;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    .mat-mdc-text-field-wrapper {\r\n      background-color: #fff !important;\r\n      width: 100%;\r\n    }\r\n\r\n    .mat-mdc-input-element,\r\n    .mat-mdc-select-value {\r\n      font-size: 11px !important;\r\n    }\r\n\r\n    .mat-mdc-form-field-subscript-wrapper {\r\n      display: none !important;\r\n    }\r\n  }\r\n\r\n  /* Force same visual shell as pipeline autocomplete for Field/Operator/Value/Pipeline controls */\r\n  .routing-common-form .routing-field.mat-mdc-form-field,\r\n  .routing-common-form .routing-select-operator.mat-mdc-form-field,\r\n  .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field),\r\n  .routing-common-form .routing-rulename.mat-mdc-form-field,\r\n  .routing-common-form .routing-hl7-composite.mat-mdc-form-field,\r\n  .routing-common-form .routing-pipeline.mat-mdc-form-field {\r\n    margin: 0 !important;\r\n    --mat-form-field-container-height: 36px;\r\n    --mat-form-field-container-vertical-padding: 8px;\r\n    --mdc-outlined-text-field-container-height: 36px;\r\n\r\n    .mat-mdc-input-element,\r\n    .mat-mdc-select-value {\r\n      font-size: 12px !important;\r\n      line-height: 20px !important;\r\n    }\r\n\r\n    .mat-mdc-text-field-wrapper,\r\n    .mdc-text-field--outlined {\r\n      min-height: 36px;\r\n      height: 36px;\r\n      border-radius: 4px;\r\n      background: #ffffff !important;\r\n    }\r\n\r\n    .mat-mdc-form-field-infix {\r\n      min-height: 36px !important;\r\n      padding-top: 8px !important;\r\n      padding-bottom: 8px !important;\r\n    }\r\n\r\n    .mat-mdc-select-trigger {\r\n      min-height: 20px;\r\n      height: 20px;\r\n      align-items: center;\r\n    }\r\n\r\n    .mdc-notched-outline__leading,\r\n    .mdc-notched-outline__notch,\r\n    .mdc-notched-outline__trailing {\r\n      border-color: #cfd8e3 !important;\r\n    }\r\n  }\r\n\r\n  /* Default: label centered in box; on focus/value floats to notch (not floatLabel=\"always\") */\r\n  .routing-common-form .routing-field.mat-mdc-form-field,\r\n  .routing-common-form .routing-select-operator.mat-mdc-form-field,\r\n  .routing-common-form .routing-value.mat-mdc-form-field:not(.rule-value-inline-field),\r\n  .routing-common-form .routing-rulename.mat-mdc-form-field {\r\n    overflow: visible !important;\r\n\r\n    .mat-mdc-text-field-wrapper,\r\n    .mat-mdc-form-field-flex,\r\n    .mdc-text-field--outlined {\r\n      overflow: visible !important;\r\n    }\r\n\r\n    .mdc-floating-label:not(.mdc-floating-label--float-above) {\r\n      top: 50% !important;\r\n      transform: translateY(-50%) !important;\r\n    }\r\n\r\n    .mat-mdc-floating-label--float-above,\r\n    .mdc-floating-label--float-above {\r\n      top: -9px !important;\r\n      transform: scale(0.75) !important;\r\n      transform-origin: left top;\r\n      background: #fff;\r\n      padding: 0 4px;\r\n      z-index: 1;\r\n    }\r\n\r\n    &.mat-focused .mat-mdc-floating-label,\r\n    &.mat-focused .mdc-floating-label {\r\n      color: #0f766e !important;\r\n    }\r\n  }\r\n\r\n  .routing-common-form .routing-select-operator.mat-mdc-form-field {\r\n    .mat-mdc-select-value,\r\n    .mat-mdc-select-value-text {\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      white-space: nowrap;\r\n    }\r\n  }\r\n\r\n  /* Chip Value: mat-form-field notched outline — see rule-value-inline-mat-field mixin */\r\n}\r\n\r\n/* Version dropdown option styling (only latest item gets highlight colors) */\r\n.rc-version-live {\r\n  color: #2d862d;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n}\r\n\r\n.rc-version-devqc {\r\n  color: #ff9900;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n}\r\n\r\n.rc-version-default {\r\n  font-size: 12px;\r\n}\r\n\r\n.qc-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.35);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10;\r\n}\r\n\r\n.qc-modal {\r\n  width: 80%;\r\n  max-width: 1000px;\r\n  max-height: 85%;\r\n  background: #fff;\r\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.compare-modal {\r\n  max-width: 95vw;\r\n  width: 95vw;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.compare-header {\r\n  border-bottom: 1px solid #dee2e6;\r\n  padding: 10px 16px;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.compare-subtitle {\r\n  font-weight: normal;\r\n  color: #0d6efd;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.compare-body {\r\n  padding: 14px 16px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n}\r\n\r\n.compare-version-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  align-items: center;\r\n  gap: 0;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.compare-version-field--left {\r\n  justify-self: start;\r\n  grid-column: 1;\r\n}\r\n\r\n.compare-version-field--right {\r\n  justify-self: start;\r\n  grid-column: 2;\r\n}\r\n\r\n.compare-version-field {\r\n  flex: 0 1 auto;\r\n  min-width: 160px;\r\n  max-width: 280px;\r\n  width: 100%;\r\n  height: 44px;\r\n}\r\n\r\n:host ::ng-deep .compare-version-field {\r\n  .mat-mdc-text-field-wrapper {\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n    height: 40px;\r\n  }\r\n\r\n  .mat-mdc-form-field-infix {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n    min-height: 40px;\r\n  }\r\n\r\n  .mat-mdc-floating-label,\r\n  mat-label {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .mat-mdc-select-value,\r\n  .mat-mdc-select-placeholder {\r\n    font-size: 0.875rem;\r\n  }\r\n}\r\n\r\n.compare-diff-container {\r\n  flex: 1;\r\n  min-height: 400px;\r\n}\r\n\r\n.version-notes-modal {\r\n  max-width: 90vw;\r\n  width: 70vw;\r\n}\r\n\r\n.version-notes-header {\r\n  border-bottom: 1px solid #dee2e6;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.version-notes-subtitle {\r\n  font-weight: normal;\r\n  color: #0d6efd;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.version-notes-body {\r\n  max-height: 60vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.version-notes-loading,\r\n.version-notes-empty {\r\n  text-align: center;\r\n  padding: 24px;\r\n}\r\n\r\n.version-notes-list {\r\n  padding-right: 6px;\r\n}\r\n/* Two-column layout — full-height vertical split */\r\n.routing-main-split {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  align-items: stretch;\r\n  gap: 0;\r\n  padding: 0;\r\n  border-top: 1px solid $routing-border;\r\n}\r\n\r\n.routing-pipeline-left {\r\n  flex: 0 0 28%;\r\n  width: 28%;\r\n  max-width: 28%;\r\n  min-width: 220px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  overflow: hidden;\r\n  border: none;\r\n  border-right: 2px solid #cbd5e1;\r\n  border-radius: 0;\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n  align-self: stretch;\r\n}\r\n\r\n.routing-left-pipeline-search-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.routing-left-pipeline-search {\r\n  flex: 1;\r\n  min-width: 0;\r\n  margin: 0;\r\n}\r\n\r\n.routing-left-pipeline-new-btn {\r\n  flex-shrink: 0;\r\n  white-space: nowrap;\r\n  margin: 0;\r\n  padding: 1px 6px;\r\n  height: 30px;\r\n  min-height: 30px;\r\n  line-height: 1;\r\n  font-size: 10px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 3px;\r\n  box-sizing: border-box;\r\n  align-self: center;\r\n\r\n  .fa {\r\n    font-size: 9px;\r\n  }\r\n}\r\n\r\n.routing-left-pipeline-autocomplete {\r\n  width: 100%;\r\n  min-width: 0;\r\n  margin: 0;\r\n}\r\n\r\n:host ::ng-deep .routing-left-pipeline-autocomplete .ng-autocomplete {\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n:host ::ng-deep .routing-left-pipeline-autocomplete .autocomplete-container {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  margin: 0 !important;\r\n  height: 36px !important;\r\n  min-height: 36px !important;\r\n  box-shadow: none !important;\r\n  border-radius: 4px !important;\r\n}\r\n\r\n:host ::ng-deep .routing-left-pipeline-autocomplete .autocomplete-container .input-container {\r\n  height: 36px !important;\r\n  min-height: 36px !important;\r\n}\r\n\r\n:host ::ng-deep .routing-left-pipeline-autocomplete .autocomplete-container .input-container input {\r\n  height: 34px !important;\r\n  min-height: 34px !important;\r\n  line-height: 34px !important;\r\n  padding: 0 10px !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n:host ::ng-deep .routing-left-pipeline-autocomplete .input-container {\r\n  font-size: 12px;\r\n  min-height: 36px;\r\n  height: 36px;\r\n  border: 1px solid #cfd8e3;\r\n  border-radius: 4px;\r\n  background: #ffffff;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.routing-left-pipeline-nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n  min-height: 0;\r\n  margin-top: 4px;\r\n  padding-top: 2px;\r\n}\r\n\r\n.routing-left-pipeline-item {\r\n  width: 100%;\r\n  text-align: left;\r\n  border: 1px solid #b8e0dc;\r\n  border-left: 3px solid #80cbc4;\r\n  border-radius: 4px;\r\n  background: white;//#f0fdfa;\r\n  padding: 5px 8px;\r\n  font-size: 10px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 2px;\r\n  box-sizing: border-box;\r\n  transition:\r\n    background-color 0.15s ease,\r\n    border-color 0.15s ease,\r\n    border-left-width 0.15s ease,\r\n    box-shadow 0.15s ease;  \r\n\r\n  &:hover {\r\n    background: #e0f7f5;\r\n    border-color: #9dd9d2;\r\n    border-left-color: #4db6ac;\r\n  }\r\n\r\n}\r\n\r\n.routing-left-pipeline-item--active {\r\n  background: #e0f2f1;\r\n  border-color: #80cbc4;\r\n  border-left-width: 3px;\r\n  border-left-color: #00796b;\r\n\r\n  &:hover {\r\n    background: #d4eeec;\r\n    border-left-color: #00695c;\r\n  }\r\n}\r\n\r\n.routing-left-pipeline-item-label {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  line-height: 1.25;\r\n  color: #00796b;\r\n  word-break: break-word;\r\n  width: 100%;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.routing-left-pipeline-item-meta {\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  line-height: 1.2;\r\n  color: #00897b;\r\n}\r\n\r\n.routing-left-pipeline-item--active .routing-left-pipeline-item-label {\r\n  color: #00695c;\r\n}\r\n\r\n.routing-left-pipeline-item--active .routing-left-pipeline-item-meta {\r\n  color: #00796b;\r\n  font-weight: 600;\r\n}\r\n\r\n.routing-left-pipeline-total {\r\n  flex-shrink: 0;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: $routing-muted;\r\n  padding-top: 6px;\r\n  border-top: 1px solid $routing-border;\r\n}\r\n\r\n.routing-pipeline-right {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  width: auto;\r\n  max-width: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  background: #f9fafb;\r\n  align-self: stretch;\r\n}\r\n\r\n.routing-pipeline-right > .routing-expression-bar,\r\n.routing-pipeline-right > .routing-expression-bar--sticky {\r\n  order: 3;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.routing-field-cell { flex: 46 1 0; min-width: 0; }\r\n.routing-field-cell--hl7,\r\n.routing-field-cell--xml {\r\n  flex: 0 0 auto;\r\n  width: auto;\r\n  max-width: none;\r\n  min-width: 0;\r\n}\r\n.routing-xml-field-group {\r\n  flex: 0 0 auto;\r\n  width: auto;\r\n  min-width: 0;\r\n}\r\n.routing-xml-field-row {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: flex-end;\r\n  gap: 8px;\r\n  width: auto;\r\n}\r\n.routing-xml-field-row .routing-field {\r\n  flex: 1 1 360px;\r\n  width: min(100%, 520px);\r\n  min-width: 320px;\r\n  max-width: 520px;\r\n  margin: 0 !important;\r\n}\r\n.routing-xml-build-path-wrap {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  padding-bottom: 0;\r\n}\r\n.routing-hl7-field-group {\r\n  flex: 0 0 auto;\r\n  width: auto;\r\n  min-width: 0;\r\n}\r\n.routing-hl7-field-row {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: flex-end;\r\n  gap: 8px;\r\n  width: auto;\r\n}\r\n.routing-hl7-field-block {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  min-height: 36px;\r\n  height: 36px;\r\n  padding: 0 12px;\r\n  border: 1px solid #cfd8e3;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.routing-hl7-field-block-label {\r\n  position: absolute;\r\n  top: -10px;\r\n  left: 10px;\r\n  z-index: 3;\r\n  padding: 0 5px;\r\n  font-size: 11px;\r\n  font-weight: 400;\r\n  line-height: 1.1;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  background: #fff;\r\n  pointer-events: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.routing-hl7-field-shell {\r\n  display: inline-flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 0;\r\n  width: max-content;\r\n  height: 20px;\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n.routing-hl7-build-path-wrap {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  padding-bottom: 0;\r\n}\r\n.routing-hl7-sep {\r\n  flex: 0 0 auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #64748b;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  user-select: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  width: 0.35em;\r\n}\r\n\r\n.routing-hl7-segment-input {\r\n  flex: 0 0 auto;\r\n  width: 4.5ch;\r\n  min-width: 3ch;\r\n  max-width: 5ch;\r\n  height: 20px;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 20px;\r\n  text-align: left;\r\n  color: inherit;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.routing-hl7-index-input {\r\n  flex: 0 0 auto;\r\n  width: 2.5ch;\r\n  min-width: 1.5ch;\r\n  max-width: 2.5ch;\r\n  height: 20px;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  font-size: 12px;\r\n  line-height: 20px;\r\n  text-align: center;\r\n  color: inherit;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.routing-hl7-index-input::placeholder,\r\n.routing-hl7-segment-input::placeholder {\r\n  color: rgba(0, 0, 0, 0.38);\r\n}\r\n\r\n.routing-empty-pipelines { margin: 16px 20px; }\r\n.routing-compact-row.routing-rule-part-1 { flex-wrap: nowrap; align-items: center; }\r\n.routing-rulename-cell {\r\n  min-width: 0;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n.routing-rulename-cell .routing-rulename { width: 100%; box-sizing: border-box; }\r\n\r\n/* XML/HL7 field inside grid column — must not steal width on edit */\r\n.routing-rule-part-1 > .routing-field-cell,\r\n.routing-rule-part-1 > .routing-field-cell--xml {\r\n  min-width: 0;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  overflow: visible;\r\n}\r\n\r\n.routing-rule-part-1 > .routing-field-cell--hl7 {\r\n  min-width: 0;\r\n  width: auto;\r\n  max-width: none;\r\n  overflow: visible;\r\n}\r\n\r\n.routing-rule-part-1 .routing-xml-field-group,\r\n.routing-rule-part-1:not(.routing-rule-part-1--hl7) .routing-hl7-field-group {\r\n  width: 100%;\r\n  min-width: 0;\r\n  max-width: 100%;\r\n}\r\n\r\n.routing-rule-part-1 .routing-xml-field-row,\r\n.routing-rule-part-1:not(.routing-rule-part-1--hl7) .routing-hl7-field-row {\r\n  width: 100%;\r\n  min-width: 0;\r\n  max-width: 100%;\r\n}\r\n\r\n.routing-rule-part-1 .routing-xml-field-row .routing-field {\r\n  flex: 1 1 0;\r\n  width: 100%;\r\n  min-width: 0 !important;\r\n  max-width: 100% !important;\r\n\r\n  .mat-mdc-input-element {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n.routing-value-col .rule-value-inline-field.mat-mdc-form-field {\r\n  margin-top: 0;\r\n}\r\n.routing-selected-pipeline-header { cursor: default; }\r\n\r\n/* Segment autocomplete — panel wider than narrow input trigger */\r\n::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.routing-hl7-segment-autocomplete-panel {\r\n  min-width: 160px !important;\r\n  width: auto !important;\r\n  max-width: 240px !important;\r\n}\r\n\r\n::ng-deep .cdk-overlay-container .routing-hl7-segment-autocomplete-panel .mat-mdc-option {\r\n  min-height: 36px;\r\n  padding: 0 12px;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* mat-select — see routing-mat-select-overlay.util.ts */\r\n::ng-deep body.routing-mat-select-open\r\n  .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {\r\n  pointer-events: none !important;\r\n}\r\n\r\n::ng-deep .mat-mdc-select-panel.routing-mat-select-panel {\r\n  z-index: 10001 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
